import { useEffect, useState } from "react";
import { JigsawPuzzle } from "react-jigsaw-puzzle/lib";
import "react-jigsaw-puzzle/lib/jigsaw-puzzle.css";
import ReactTooltip from "react-tooltip";
import common from "../utils/common";
import "./Game.scss";
import Popup from "./Popup";
import WhackAMole from "./games/WhackAMole";
import Memory from "./games/Memory";
import Color from "./games/Color";
import Breathe from "./games/Breathe";
import Piñata from "./games/Piñata";
import Connect4 from "./games/connect4/Connect";
import Phaser from "./games/phaser/component";

const Info = "/img/emotions/info.svg";

const GAME_MAP = {
    REARRANGE_PUZZLE_1: {
      type: "PUZZLE",
      image: "/img/emotions/apple-yellow.png",
      rows: 2,
      columns: 2,
    },
    REARRANGE_PUZZLE_2: {
      type: "PUZZLE",
      image: "/img/emotions/apple-red.png",
      rows: 2,
      columns: 2,
    },
    WHACK_A_MOLE: {
      type: "WHACK_A_MOLE",
    },
    MEMORY: {
      type: "MEMORY",
    },
    COLOR: {
      type: "COLOR",
    },
    BREATHE: {
      type: "BREATHE",
    },
    PIÑATA: {
      type: "PIÑATA",
    },
    CONNECT4: {
      type: "CONNECT4",
    },
    CLEARSKY: {
      type: "CLEARSKY",
    },
  },
  GAMES = Object.keys(GAME_MAP),
  PHASER_GAMES = ["CLEARSKY"];
const resolveGame = (
  data,
  done,
  feature,
  start,
  end,
  intro,
  share,
  payload
) => {
  switch (data.type) {
    case "PUZZLE":
      return (
        <JigsawPuzzle
          imageSrc={data.image}
          rows={data.rows}
          columns={data.columns}
          onSolved={done}
          feature={feature}
          start={start}
          end={end}
        />
      );
    case "WHACK_A_MOLE":
      return (
        <WhackAMole feature={feature} onDone={done} start={start} end={end} />
      );
    case "MEMORY":
      return <Memory feature={feature} onDone={done} start={start} end={end} />;
    case "COLOR":
      return <Color feature={feature} onDone={done} start={start} end={end} />;
    case "BREATHE":
      return (
        <Breathe feature={feature} onDone={done} start={start} end={end} />
      );
    case "PIÑATA":
      return <Piñata feature={feature} onDone={done} start={start} end={end} />;
    case "CONNECT4":
      return (
        <Connect4
          feature={feature}
          onDone={done}
          start={start}
          end={end}
          intro={intro}
          share={share}
        />
      );
    case "CLEARSKY":
      return (
        <Phaser
          payload={{ ...payload, payload: JSON.parse(payload.payload) }}
        />
      );
    default:
      return null;
  }
};
const Game = ({
  content,
  start = null,
  end = null,
  feature = "EMOTION",
  next,
}) => {
  const { game, heading, info, intro = "", share = {} } = content,
    { heading: infoHeading = null, body = null } = info ? info : {},
    [data, setData] = useState(null),
    [popup, setPopup] = useState(null),
    [fullScreen, setFullScreen] = useState(false),
    done = () => {
      if (start === null) {
        if (content.on_complete) {
          setPopup(content.on_complete);
        } else {
          (async () => {
            await common.sleep(1500);
            next(1);
          })();
        }
      } else {
        window.flutter_inappwebview.callHandler(
          "gameCloseEvent_closeGame",
          "*"
        );
        // next();
      }
    };
  useEffect(() => {
    setData(GAME_MAP[game]);
    setFullScreen(PHASER_GAMES.includes(game));
  }, [content, game]);
  return (
    <>
      <div className="emotion-game">
        {!fullScreen && (
          <div className="emotion-game-heading">
            <div className="emotion-game-title emotion-text">{heading}</div>
            {infoHeading && (
              <div
                className="emotion-game-info"
                style={{
                  backgroundImage: `url(${Info})`,
                  backgroundSize: "100% 100%",
                }}
                data-tip
                data-for="info-tooltip"
              >
                <ReactTooltip
                  id="info-tooltip"
                  place="right"
                  type="light"
                  effect="float"
                >
                  <div className="emotion-tooltip">
                    <div className="emotion-text">{infoHeading}</div>
                    {body
                      .split(".")
                      .filter((item) => item.trim().length > 0)
                      .map((item, itemIndex) => (
                        <div key={`body${itemIndex}`}>{`${item}.`}</div>
                      ))}
                  </div>
                </ReactTooltip>
              </div>
            )}
          </div>
        )}
        {data &&
          resolveGame(data, done, feature, start, end, intro, share, content)}
      </div>
      {popup && <Popup data={popup} next={next} />}
    </>
  );
};

export default Game;
export { GAMES, PHASER_GAMES };
